import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-practitioner-info-dialog',
  templateUrl: './practitioner-info-dialog.component.html',
  styleUrls: ['./practitioner-info-dialog.component.scss'],
})
export class PractitionerInfoDialogComponent extends BaseComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData, 
    public injector: Injector,
    private dialogRef: MatDialogRef<PractitionerInfoDialogComponent>
  ) {
    super(injector)
  }

  public practitioner: any;
  public practitionerRole: any;

  

  ngOnInit(): void {
    this.practitioner = this.data.param.specialist;
    this.practitionerRole = this.data.param.practitionerRole;
  }

  formatDate(dateString: string): string {
    if (!dateString || dateString.length !== 6) return 'Data inválida';
    const month = dateString.substring(0, 2);
    const year = dateString.substring(2);
    return `${month}/${year}`;
  }

  getPractitionerPhoto() {
    const url = this.practitioner  && this.practitioner.photo ? this.practitioner.photo : this.defaultPractitionerPhoto;
    return url;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
